import {
  AddSessionPageRequest,
  SessionPageCollection,
  SessionPageDetails,
  SessionPagePartialModel,
  UpdateSessionPageRequest
} from '../models/api';
import { deleteData, getData, patchData, postData, putData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const list = async (
  sessionReference: string
): Promise<ResponseData<SessionPageCollection>> =>
  getData<SessionPageCollection>(`api/sessions/${sessionReference}/pages`);
export const listAll = async (
  sessionReference: string
): Promise<ResponseData<SessionPageCollection>> =>
  getData<SessionPageCollection>(`api/sessions/${sessionReference}/pages/all`);
export const add = async (
  sessionReference: string,
  model: AddSessionPageRequest
): Promise<ResponseData<SessionPageDetails>> =>
  postData<SessionPageDetails>(`api/sessions/${sessionReference}/pages`, model);
export const remove = async (
  sessionReference: string,
  pageReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  deleteData(`api/sessions/${sessionReference}/pages/${pageReference}`);
export const updatePages = async (
  sessionReference: string,
  pages: SessionPagePartialModel[]
): Promise<ResponseData<SessionPageCollection>> =>
  patchData<SessionPageCollection>(`api/sessions/${sessionReference}/pages`, {
    pages: pages
  });
export const update = async (
  sessionReference: string,
  sessionPageReference: string,
  model: UpdateSessionPageRequest
): Promise<ResponseData<SessionPageDetails>> =>
  putData<SessionPageDetails>(
    `api/sessions/${sessionReference}/pages/${sessionPageReference}`,
    model
  );
